export default __webpack_public_path__ + "images/Nydree-Logo-Website.3cd12a39f8769df6599c22cb0661793e.png";